export const cognitoAuthConfig = {
  authority: process.env.GATSBY_COGNITO_AUTHORITY,
  client_id: process.env.GATSBY_COGNITO_CLIENT_ID,

  // IMPORTANT: this is your callback page route
  redirect_uri: `${process.env.GATSBY_SITE_URL}/auth/callback`,

  // After logout, Cognito redirects here
  post_logout_redirect_uri:
    typeof window !== 'undefined'
      ? `${window.location.origin}/`
      : 'https://www.mamabearu.com/',

  response_type: 'code',

  // Minimal recommended scopes
  scope: 'openid email',
};

if (typeof window !== 'undefined') {
  window.__COGNITO__ = {
    authority: process.env.GATSBY_COGNITO_AUTHORITY,
    clientId: process.env.GATSBY_COGNITO_CLIENT_ID,
    siteUrl: process.env.GATSBY_SITE_URL,
  };
}
